import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { SimpleNotification, SimpleNotificationType } from '../models/SimpleNotification.model';

// Reducers
import * as fromCore from '../../../../core/reducers';

// Actions
import * as CoreActions from '../../../../core/actions/ui.actions';

@Injectable()
export class SimpleNotificationService {

  private keepAfterRouteChange = false;

  constructor(
    private router: Router,
    private store: Store<fromCore.State>
  ) {
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert messages
          this.clear();
        }
      }
    });
  }

  success(message: string, keepAfterRouteChange = false) {
    this.notification(SimpleNotificationType.Success, message, keepAfterRouteChange);
  }

  error(message: string, keepAfterRouteChange = false) {
    this.notification(SimpleNotificationType.Error, message, keepAfterRouteChange);
  }

  info(message: string, keepAfterRouteChange = false) {
    this.notification(SimpleNotificationType.Info, message, keepAfterRouteChange);
  }

  warn(message: string, keepAfterRouteChange = false) {
    this.notification(SimpleNotificationType.Warning, message, keepAfterRouteChange);
  }

  notification(type: SimpleNotificationType, message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.store.dispatch(new CoreActions.AddSimpleNotification({ type: type, message: message }));
  }

  clear() {
    // clear notifications
    this.store.dispatch(new CoreActions.ClearSimpleNotifications());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/simple-notification/services/SimpleNotification.service.ts